import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { renderComponentField } from '@/shared/components/form/FormField';
import styled from 'styled-components';
import { colorBlue, colorAccent, colorBackground, colorFieldsBorder, colorText } from '@/utils/palette';

export const SelectField = React.forwardRef(({ label, error, ...rest }, ref) => {
  return (
    <>
      {label && <Label style={{ color: `${error ? 'red' : '#1F1F1F'}` }}>{label}</Label>}
      <StyledSelect
        ref={ref}
        classNamePrefix='react-select'
        menuPortalTarget={document.body}
        styles={customStyles}
        maxMenuHeight={400}
        error={error ? true : false}
        label={label}
        {...rest}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  );
});

SelectField.displayName = 'SelectField';

SelectField.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]),
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]),
};

export default renderComponentField(SelectField);

// region STYLES

const ErrorMessage = styled.div`
  color: red;
  margin-top: -25px;
  margin-bottom: 20px;
  font-size: 12px;
`;

const Label = styled.div`
  font-size: 12px;
  margin-top: 5px;
`;

const customStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (styles, state) => {
    return {
      ...styles,
      backgroundColor: state?.isSelected ? colorBlue : state?.isFocused ? '#f0f0f0' : 'white',
      color: state?.isSelected ? 'white' : 'black',
      cursor: state?.isDisabled ? 'not-allowed' : 'default',
    };
  },
};

const StyledSelect = styled(Select)`
  // border: 1px solid black;
  width: 100%;
  // height: 40px;
  margin-bottom: 25px;
  background-color: ${colorBackground} !important;
  color: black !important;
  box-shadow:
    inset 0 0 0 1px ${colorAccent},
    none !important;
  border-bottom: 1px solid ${colorFieldsBorder};
  border-radius: 0px;

  &:hover {
    border-bottom: 2px solid ${colorAccent};
    cursor: pointer;
  }

  .react-select__defaultValue {
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    margin-top: -2px;
    color: ${colorText};
  }

  .react-select__placeholder {
    font-size: 12px;
    font-family: 'Inter', sans-serif;
    margin-bottom: -12px;
    color: ${(props) => (props.error ? 'red' : colorText)} !important;
    margin-left: -8px;
  }

  .react-select__control {
    // height: 48px;
    border-bottom: 1px solid ${(props) => (props.error ? 'red' : colorFieldsBorder)} !important;
    background-color: ${colorBackground};
    color: ${colorText};
    box-shadow: none !important;
    border-style: none;
    border-radius: 0px;
    transition: border-bottom 0.3s ease;

    &:hover {
      border-bottom: 1px solid ${(props) => (props.error ? 'red' : colorAccent)} !important;
      cursor: pointer;
    }
  }

  &.react-select__control--is-focused,
  &:hover {
    border-bottom: 2px solid ${colorAccent} !important;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__indicator {
    padding: 0;
  }

  .react-select__dropdown-indicator,
  .react-select__clear-indicator {
    background-color: ${colorBackground};
    cursor: pointer;
    color: ${colorText} !important;

    svg {
      height: 22px;
      width: 22px;
    }
  }

  .react-select__single-value {
    color: ${colorText};
    margin-left: -8px;
    font-size: 12px;
  }

  .react-select__menu {
    // margin-top: 8px;
    border-radius: 1px;
    background: ${colorBackground};
    color: ${colorText};
    border-bottom: 1px solid ${colorFieldsBorder};
    z-index: 9999;

    &.react-select__menu--is-focused,
    &.react-select__menu--is-selected {
      background-color: ${colorAccent} !important;
      color: white !important;
    }

    // .react-select__menu-list {
    //   background:${colorAccent};
    // }

    .react-select__option {
      padding: 5px 10px;
      cursor: pointer;
      color: ${colorText};
      background: ${colorBackground};

      &.react-select__option--is-focused,
      &.react-select__option--is-selected {
        background-color: ${colorAccent} !important;
        color: white !important;
      }

      &:hover {
        background-color: ${colorAccent} !important;
        color: white !important;
      }
    }
  }
`;
